import { AutogenModelDepartment, AutogenRowDepartment } from "./autogen/AutogenModelDepartment";

export class ModelDepartment extends AutogenModelDepartment<RowDepartment> {
    constructor() {
        super(RowDepartment);
    }
}

export class RowDepartment extends AutogenRowDepartment {
}